//@flow

export const getCurrencyFormat = (number, prefix, defaultValue) => {
  if (typeof number === "string") {
    number = number.replace(",", ".");
  }

  if (isNaN(number)) {
    return defaultValue;
  }

  return (
    prefix +
    Number(number).toLocaleString("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
  );
};
